import { Component, ViewContainerRef } from "@angular/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  host: {'class': 'flex'}
})
export class AppComponent {

  constructor (public viewContainerRef : ViewContainerRef){
    
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/app.component.ts